import { QueryFeature } from '../../../config/queryClient';
import { ProviderType } from '../DocumentVault.meta';

enum QueryKey {
  ListDocumentVaultEntities = 'ListDocumentVaultEntities',
  EStatementPreferences = 'EStatementPreferences',
  FidelityAvailableUsersList = 'FidelityAvailableUsersList',
  SearchDocumentVaultEntities = 'SearchDocumentVaultEntities',
}

export const queryKeys = {
  listDocumentVaultEntities: (
    clientId: number | string | null = null,
    path: string | null = null,
    providerType: ProviderType | null = null,
    currentYear: number | null = null,
    tokenId: string | null = null,
  ) =>
    [
      QueryFeature.DocumentVault,
      QueryKey.ListDocumentVaultEntities,
      clientId,
      path,
      providerType,
      currentYear,
      tokenId,
    ].filter(key => key !== null),

  eStatementPreferences: clientId => [
    QueryFeature.DocumentVault,
    QueryKey.EStatementPreferences,
    clientId,
  ],

  fidelityAvailableUsersList: clientId => [
    QueryFeature.DocumentVault,
    QueryKey.FidelityAvailableUsersList,
    clientId,
  ],

  searchDocumentVaultEntities: (
    clientId: number | string | null = null,
    path: string | null = null,
    providerType: ProviderType | null = null,
    currentYear: number | null = null,
    tokenId: string | null = null,
    searchTerm: string | null = null,
  ) =>
    [
      QueryFeature.DocumentVault,
      QueryKey.SearchDocumentVaultEntities,
      clientId,
      path,
      providerType,
      currentYear,
      tokenId,
      searchTerm,
    ].filter(key => key !== null),
};
